import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export class UCIExpiredError extends CodedError {
  static get errorName() {
    return errorCodes.uciExpiredError.code;
  }

  constructor(message: string = errorCodes.uciExpiredError.message) {
    super(message);
    this.code = errorCodes.uciExpiredError.code;
    this.message = `${message} ${errorCodes.uciExpiredError.code}`;
    this.name = errorCodes.uciExpiredError.name;
  }
}
